import { render, staticRenderFns } from "./NewMessageFalseIcon.vue?vue&type=template&id=6d2acf12&scoped=true"
import script from "./NewMessageFalseIcon.vue?vue&type=script&lang=js"
export * from "./NewMessageFalseIcon.vue?vue&type=script&lang=js"
import style0 from "./NewMessageFalseIcon.vue?vue&type=style&index=0&id=6d2acf12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2acf12",
  null
  
)

export default component.exports